import { camelizeKeys } from 'humps'

const leaguesPlugin = (state = {}, {type, payload}) => {
  switch (type) {
    case 'LEAGUES_PLUGIN.INIT':
      return {
        ...state,
        ...camelizeKeys(payload),
      }
    default:
      return state
  }
}

export default leaguesPlugin
